
import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import InnerHeading from "../../Global Functions/innerHeading";
import { ReactComponent as Add } from "../../Global Icons/Add Cab.svg";
import { useNavigate, useParams } from "react-router-dom";
import TextInput from "../../Global Functions/textInput";
import SelectInput from "../../Global Functions/selectInput";
import { useDispatch, useSelector } from "react-redux";
import {
  viewCountry,
  viewCountryListPagination,
} from "../../Redux/Actions/settingsActions";
import { ScrollTop, ToFirstCapital } from "../../Utils/helpers";
import {
  editCabCategory,
  viewCabRequest,
} from "../../Redux/Actions/cabRequestActions";
import toast from "react-hot-toast";
import TwoButtons from "../../Global Functions/buttons";
import { getEnums } from "../../Redux/Actions/enumsActions";
import AddImage from "../../Global Functions/addImage";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";

const EditCabCategory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const { countryList, country } = useSelector((state) => state.country || {});
  const { enumsData } = useSelector((state) => state.enumsData || {});
  const { cab } = useSelector((state) => state.cabs || {});
  const [cabState, setCabState] = useState({
    _id: id,
    type: cab?.data?.type,
    name: cab?.data?.name,
    country: cab?.data?.country?._id,
    rate_per_unit: cab?.data?.rate_per_unit,
    rate_per_unit_measure_in: cab?.data?.rate_per_unit_measure_in,
    image: cab?.data?.image,
    status: cab?.data?.status,
    position: Math.floor(Math.random() * 1000 + 1),
  });
  const cabSettingsNavigator = () => {
    navigate("/cab_settings");
  };

  const handleAddChange = async (event) => {
    const { name, value, files } = event.target;
    if (name === "image") {
      const file = files && files[0];
      if (!file) return;

      const res = await AddImage(file);
      if (res) {
        setCabState((prevData) => ({
          ...prevData,
          [name]: res,
        }));
      }
      return;
    }
    setCabState((prevData) => ({ ...prevData, [name]: value }));
  };

  useEffect(() => {
    ScrollTop();
    dispatch(viewCountryListPagination());
    dispatch(getEnums());
    dispatch(viewCabRequest(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (cab?.data) {
      setCabState({
        id: id,
        name: cab?.data?.name || "",
        country: cab?.data?.country?._id || "",
        rate_per_unit: cab.data.rate_per_unit || "",
        rate_per_unit_measure_in: cab.data.rate_per_unit_measure_in || country?.data?.country_currency || "",
        type: cab?.data?.type || "",
        image: cab?.data?.image || "",
        status: cab.data.status || "",
        no_of_seats:cab?.data?.no_of_seats || "",
        position: Math.floor(Math.random() * 1000 + 1),
      });
    }
  }, [cab, id, country?.data?.country_currency]);

  useEffect(() => {
    dispatch(viewCountry(cabState.country));
  }, [cabState?.country, dispatch]);

  const handleSubmit = async () => {
    try {
      // if (
      //   Object.values(cabState).some(
      //     (value) => value === null || value === "" || value === undefined
      //   )
      // ) {
      //   return toast.error("Input fields cannot be empty!!");
      // }
      const response = await dispatch(editCabCategory(cabState));
      if (response.statusCode === 200) {
        navigate("/cab_settings");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  return (
    <MainLayout>
      <div className="bg-white grid-span-5 radius-20 padding-20 grid-template-2 gap-10 full-screen full-height">
        <InnerHeading
          Icon={Add}
          heading="Edit Cab Category"
          buttonLabel="View Categories"
          onClick={cabSettingsNavigator}
        ></InnerHeading>

        <TextInput
          label="Name"
          name="name"
          type="string"
          value={cabState.name}
          onChange={handleAddChange}
          disabled
        />

        <SelectInput
          disabled
          label="Type"
          placeholder="Select an option"
          required
          value={cabState.type}
          name="type"
          onChange={handleAddChange}
          options={
            enumsData?.data?.cabIcons
              ? Object.entries(enumsData.data.cabIcons).map(([key, _]) => ({
                label: ToFirstCapital(key),
                value: key,
              }))
              : []
          }
        ></SelectInput>

        <SelectInput
          label="Select Country"
          placeholder="Select an Option"
          value={cabState.country}
          onChange={handleAddChange}
          required
          name="country"
          disabled
          options={
            Array.isArray(countryList?.data)
              ? countryList.data.map((country) => ({
                label: country.country_name,
                value: country._id,
              }))
              : []
          }
        ></SelectInput>

        <TextInput
          disabled
          onChange={handleAddChange}
          name="currency"
          label="Currency"
          value={country?.data?.country_currency || ""}
        ></TextInput>
        <TextInput
          name="rate_per_unit"
          onChange={handleAddChange}
          label="Rate"
          value={cabState.rate_per_unit}
        ></TextInput>

        <TextInput
          name="rate_per_unit_measure_in"
          onChange={handleAddChange}
          label="Rate per unit measure in"
          value={cabState.rate_per_unit_measure_in}
          type="string"
          required
        ></TextInput>
        <SelectInput
          placeholder="Select Cab Status"
          required
          label="Status"
          value={cabState.status}
          onChange={handleAddChange}
          name="status"
          options={[
            { label: "Active", value: "active" },
            { label: "Inactive", value: "inactive" },
          ]}
        />
                <SelectInput
          placeholder="Select number of seats"
          required
          label="No of Seats"
          value={cabState.no_of_seats}
          onChange={handleAddChange}
          name="no_of_seats"
          options={[
            { label: "2", value: 2 },
            { label: "3", value: 3 },
            { label: "4", value: 4 },
            { label: "5", value: 5 },
            { label: "6", value: 6 },
            { label: "7", value: 7 },
          ]}
        />
         <div style={{display:"flex", flexDirection:"column"}}>
        <TextInput
          forImage={true}
          htmlFor="image"
          type="file"
          span="Brand Logo"
          label="Click to Upload Image"
          id="image"
          name="image"
          onChange={handleAddChange}
        />

        {cabState.image && (
          <ImageShowerModalGlobal
            file={cabState.image}
            keyField="image"
            setState={setCabState}
            state={cabState}
          />
        )}
        </div>

        <div className="span2">
          <TwoButtons
            buttonHead1="Cancel"
            noUrl={true}
            LinkURL="/cab_settings"
            onClick2={handleSubmit}
            buttonHead2="update"
          ></TwoButtons>
        </div>
      </div>
    </MainLayout>
  );
};

export default EditCabCategory;
